(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STEP_KEYS = ['breed', 'size', 'coat', 'length', 'problem'];

    const PROBLEM_LABELS = Object.freeze({
      shave: 'I’m worried about shave-downs',
      sensitive: 'They don’t like being brushed',
      time: 'Brushing takes too long',
      tangles: 'I brush often but still find tangles',
      cost: 'My grooming bills are too expensive',
      new: 'I’m new to brushing this type of coat'
    });

    const MINIMUM_PROBLEM_COPY = Object.freeze({
      shave:
        'That final comb check is especially important if you’re worried about shave-downs — brushing can look finished while tangles are still hiding deeper in the coat.',
      sensitive:
        'The flexible head absorbs resistance as you brush, making this a much gentler, more comfortable starting point for a brush-sensitive dog.',
      time:
        'This keeps the routine simple: one effective brush for the main job, then a quick comb-through to confirm you’re done.',
      cost:
        'Keeping the coat properly detangled at home can help reduce the matting, dematting work and shave-downs that often make grooming appointments more expensive.',
      tangles:
        'If you keep finding tangles after brushing, the comb is the missing check: if it snags, you know exactly where you need to go back and brush again.',
      new:
        'This gives you the simplest correct routine to start with: detangle with the brush, then check your work with the comb.'
    });

    const RECOMMENDED_PROBLEM_COPY = Object.freeze({
      shave:
        'If avoiding shave-downs is the goal, this gives you much better coverage of the whole coat — and the comb check means you know the job is finished rather than hoping it is.',
      sensitive:
        'Both flexible slickers absorb resistance as you brush, making the experience much more comfortable while still giving you the coverage you need across the body and tricky areas.',
      time:
        'This setup makes brushing more efficient instead of forcing one brush to do four different jobs, with the Double Head particularly useful for cutting down full-body brushing time.',
      cost:
        'This gives you a much more complete home-maintenance routine, helping prevent the hidden matting that can lead to dematting charges, difficult grooming appointments and expensive shave-downs.',
      tangles:
        'This removes the guesswork: the brushes tackle different areas and depths of the coat, then the comb tells you immediately if anything has been missed.',
      new:
        'Starting with the full routine means you have the right tool for each job from day one, rather than learning through missed tangles, uncomfortable brushing or preventable matting.'
    });

    class BrushQuizV2 {
      constructor(root) {
        this.root = root;
        this.data = root.dataset;
        this.products = {};
        this.result = null;
        this.customSelection = new Set();
        this.abortController = new AbortController();
        this.timers = new Set();
        this.storageKey = `brush-quiz-v2-${this.data.sectionId}`;

        this.state = {
          step: 1,
          answers: {},
          completed: false
        };
      }

      one(selector) {
        return this.root.querySelector(selector);
      }

      all(selector) {
        return [...this.root.querySelectorAll(selector)];
      }

      delay(callback, milliseconds) {
        const timer = window.setTimeout(() => {
          this.timers.delete(timer);
          callback();
        }, milliseconds);

        this.timers.add(timer);
        return timer;
      }

      init() {
        if (this.root.dataset.initialized === 'true') return;

        this.root.dataset.initialized = 'true';
        this.root.__brushQuizV2 = this;

        this.form = this.one('[data-bq-form]');
        this.quizColumn = this.one('[data-bq-quiz-column]');
        this.placeholder = this.one('[data-bq-placeholder]');
        this.resultsColumn = this.one('[data-bq-results-column]');
        this.results = this.one('[data-bq-results]');
        this.progress = this.one('[data-bq-progress]');
        this.progressCopy = this.one('[data-bq-progress-copy]');
        this.selectionStatus = this.one('[data-bq-selection-status]');
        this.placeholderProgress = this.one('[data-bq-placeholder-progress]');
        this.placeholderSummary = this.one('[data-bq-placeholder-summary]');
        this.formError = this.one('[data-bq-form-error]');
        this.cartError = this.one('[data-bq-cart-error]');
        this.cartStatus = this.one('[data-bq-cart-status]');

        if (
          !this.form ||
          !this.quizColumn ||
          !this.placeholder ||
          !this.resultsColumn ||
          !this.results ||
          !this.progress
        ) {
          this.destroy();
          return;
        }

        this.products = this.readProducts();
        this.restoreState();
        this.sanitizeState();
        this.syncInputsFromState();
        this.bindEvents();
        this.updatePlaceholder();

        if (this.state.completed && this.hasEveryAnswer()) {
          this.buildResults(false, false);
        } else {
          this.showQuizView();
          this.goToStep(this.state.step, false);
        }
      }

      destroy() {
        this.abortController.abort();

        this.timers.forEach((timer) => {
          window.clearTimeout(timer);
        });

        this.timers.clear();
        delete this.root.__brushQuizV2;
        delete this.root.dataset.initialized;
      }

      readProducts() {
        const products = {};

        this.all('[data-bq-product]').forEach((element) => {
          const key = element.dataset.key;
          if (!key) return;

          const imageTemplate = element.querySelector('[data-bq-product-image]');

          products[key] = {
            key,
            id: element.dataset.variantId || '',
            price: Number(element.dataset.price || 0),
            title: element.dataset.title || element.dataset.label || key,
            label: element.dataset.label || element.dataset.title || key,
            imageTemplate,
            available:
              element.dataset.available === 'true' &&
              Boolean(element.dataset.variantId)
          };
        });

        return products;
      }

      bindEvents() {
        const options = {
          signal: this.abortController.signal
        };

        this.root.addEventListener(
          'change',
          (event) => {
            if (!(event.target instanceof HTMLInputElement)) return;

            if (event.target.matches('[data-bq-answer]')) {
              this.handleAnswer(event.target);
              return;
            }

            if (!event.target.matches('[data-bq-builder-input]')) return;

            const key = event.target.value;

            if (!this.products[key]?.available) {
              event.target.checked = false;
              this.customSelection.delete(key);
            } else if (event.target.checked) {
              this.customSelection.add(key);
            } else {
              this.customSelection.delete(key);
            }

            this.updateBuilderSummary();
          },
          options
        );

        this.root.addEventListener(
          'click',
          (event) => {
            if (!(event.target instanceof Element)) return;

            const nextButton = event.target.closest('[data-bq-next]');

            if (nextButton) {
              event.preventDefault();
              this.handleNext(nextButton);
              return;
            }

            const backButton = event.target.closest('[data-bq-back]');

            if (backButton) {
              event.preventDefault();

              const currentStep = Number(
                backButton.closest('[data-bq-step]')?.dataset.bqStep || 1
              );

              this.goToStep(Math.max(1, currentStep - 1));
              return;
            }

            const addButton = event.target.closest('[data-bq-add]');

            if (addButton) {
              event.preventDefault();
              this.addToCart(addButton.dataset.bqAdd, addButton);
              return;
            }

            if (event.target.closest('[data-bq-reset]')) {
              event.preventDefault();
              this.reset();
            }
          },
          options
        );

        this.form.addEventListener(
          'submit',
          (event) => {
            event.preventDefault();
            this.syncStateFromInputs();

            if (!this.hasEveryAnswer()) {
              const missingIndex = STEP_KEYS.findIndex(
                (key) => !this.state.answers[key]
              );

              this.goToStep(missingIndex + 1);

              this.showError(
                this.formError,
                'Please choose an answer before continuing.'
              );

              return;
            }

            this.buildResults(true, true);
          },
          options
        );
      }

      handleAnswer(input) {
        if (!input?.checked || !STEP_KEYS.includes(input.dataset.bqAnswer)) {
          return;
        }

        this.state.answers[input.dataset.bqAnswer] = input.value;
        this.state.completed = false;

        this.showQuizView();
        this.hideError(this.formError);
        this.updateStepButton();
        this.updatePlaceholder();
        this.saveState();
      }

      syncStateFromInputs() {
        this.all('[data-bq-answer]:checked').forEach((input) => {
          const key = input.dataset.bqAnswer;

          if (STEP_KEYS.includes(key)) {
            this.state.answers[key] = input.value;
          }
        });
      }

      syncInputsFromState() {
        this.all('[data-bq-answer]').forEach((input) => {
          input.checked =
            this.state.answers[input.dataset.bqAnswer] === input.value;
        });
      }

      sanitizeState() {
        const validValues = {};

        STEP_KEYS.forEach((key) => {
          validValues[key] = new Set(
            this.all(`[data-bq-answer="${key}"]`).map((input) => input.value)
          );
        });

        const safeAnswers = {};

        STEP_KEYS.forEach((key) => {
          const value = this.state.answers?.[key];

          if (validValues[key].has(value)) {
            safeAnswers[key] = value;
          }
        });

        this.state.answers = safeAnswers;

        this.state.step = Math.max(
          1,
          Math.min(STEP_KEYS.length, Number(this.state.step) || 1)
        );

        this.state.completed = Boolean(
          this.state.completed && this.hasEveryAnswer()
        );
      }

      handleNext(button) {
        this.syncStateFromInputs();

        const currentStep = Number(
          button.closest('[data-bq-step]')?.dataset.bqStep
        );

        if (
          !Number.isInteger(currentStep) ||
          currentStep < 1 ||
          currentStep >= STEP_KEYS.length
        ) {
          return;
        }

        const key = STEP_KEYS[currentStep - 1];

        if (!this.state.answers[key]) {
          this.showError(
            this.formError,
            'Please choose an answer before continuing.'
          );

          this.updateStepButton();
          return;
        }

        this.goToStep(currentStep + 1);
      }

      goToStep(step, focus = true) {
        const safeStep = Math.max(
          1,
          Math.min(STEP_KEYS.length, Number(step) || 1)
        );

        this.state.step = safeStep;

        this.all('[data-bq-step]').forEach((element) => {
          element.hidden = Number(element.dataset.bqStep) !== safeStep;
        });

        this.progress.value = safeStep;
        this.progress.textContent = `${safeStep} of ${STEP_KEYS.length}`;

        this.progress.setAttribute(
          'aria-label',
          `Quiz progress: step ${safeStep} of ${STEP_KEYS.length}`
        );

        this.progressCopy.textContent =
          `Step ${safeStep} of ${STEP_KEYS.length}`;

        this.hideError(this.formError);
        this.updateStepButton();
        this.updatePlaceholder();
        this.saveState();

        if (!focus) return;

        this.scrollToTop();

        const question = this.one(
          `[data-bq-step="${safeStep}"] [data-bq-question]`
        );

        this.delay(() => {
          question?.focus({
            preventScroll: true
          });
        }, 180);
      }

      updateStepButton() {
        const step =
          this.one('[data-bq-step]:not([hidden])') ||
          this.one(`[data-bq-step="${this.state.step}"]`);

        if (!step) return;

        const key = STEP_KEYS[Number(step.dataset.bqStep) - 1];

        const checked = step.querySelector(
          `[data-bq-answer="${key}"]:checked`
        );

        if (checked) {
          this.state.answers[key] = checked.value;
        }

        const selected =
          checked?.value ||
          this.state.answers[key] ||
          '';

        const ready = Boolean(selected);

        const action = step.querySelector(
          '[data-bq-next], [data-bq-submit]'
        );

        if (action) {
          action.disabled = !ready;
          action.dataset.ready = String(ready);
        }

        const selectedLabel =
          key === 'problem'
            ? this.problemLabel(selected)
            : selected;

        this.selectionStatus.textContent = ready
          ? `Selected: ${selectedLabel}. You can continue.`
          : 'Choose one option to continue.';

        this.selectionStatus.classList.toggle('is-ready', ready);
      }

      updatePlaceholder() {
        const completed = STEP_KEYS.filter(
          (key) => Boolean(this.state.answers[key])
        ).length;

        this.placeholderProgress.textContent =
          `${completed} of ${STEP_KEYS.length} answers complete`;

        const summary = STEP_KEYS
          .filter((key) => this.state.answers[key])
          .map((key) => {
            return key === 'problem'
              ? this.problemLabel(this.state.answers[key])
              : this.state.answers[key];
          })
          .join(' · ');

        this.placeholderSummary.textContent =
          summary ||
          'Your Minimum and Recommended grooming systems will appear here.';
      }

      problemLabel(value) {
        return PROBLEM_LABELS[value] || value || '';
      }

      hasEveryAnswer() {
        return STEP_KEYS.every((key) => {
          return Boolean(this.state.answers[key]);
        });
      }

      showQuizView() {
        this.root.dataset.bqView = 'quiz';
        this.quizColumn.hidden = false;
        this.resultsColumn.hidden = true;
        this.results.hidden = true;
        this.placeholder.hidden = false;
      }

      showResultsView() {
        this.root.dataset.bqView = 'results';
        this.quizColumn.hidden = true;
        this.placeholder.hidden = true;
        this.results.hidden = false;
        this.resultsColumn.hidden = false;
      }

      getProductSets(answers) {
        const normalize = (value) => {
          return String(value || '').trim().toLowerCase();
        };

        const size = normalize(answers.size);
        const coat = normalize(answers.coat);
        const length = normalize(answers.length);
        const problem = normalize(answers.problem);

        const elpsEligibility = {
          eligibleSize: size === 'medium' || size === 'large',
          eligibleCoat: coat === 'wavy' || coat === 'curly',
          eligibleLength: length === 'medium' || length === 'long',
          eligibleProblem: problem !== 'sensitive'
        };

        const includeElps =
          Object.values(elpsEligibility).every(Boolean);

        const minimum = [
          size === 'small' ? 'shfs' : 'dhfs',
          'fc'
        ];

        const recommended = ['dhfs', 'shfs'];

        if (includeElps) {
          recommended.push('elps');
        }

        recommended.push('fc');

        return {
          minimum,
          recommended,
          includeElps,
          elpsEligibility
        };
      }

      buildResults(focus = true, track = true) {
        this.syncStateFromInputs();

        if (!this.hasEveryAnswer()) return;

        this.result = this.getProductSets(this.state.answers);
        this.state.completed = true;

        this.customSelection = new Set(
          this.result.recommended.filter((key) => {
            return this.products[key]?.available;
          })
        );

        this.renderResultsHeader();
        this.renderResult('minimum', this.result.minimum);
        this.renderResult('recommended', this.result.recommended);
        this.renderBuilder();
        this.showResultsView();
        this.hideError(this.cartError);
        this.announceCart('');
        this.saveState();

        const detail = {
          answers: {
            ...this.state.answers
          },
          minimum: [...this.result.minimum],
          recommended: [...this.result.recommended],
          includesExtraLongPinSlicker: this.result.includeElps,
          extraLongPinSlickerEligibility: {
            ...this.result.elpsEligibility
          }
        };

        if (track) {
          this.emit('brush-quiz:complete', detail);
          this.pushDataLayer('brush_quiz_complete', detail);
        }

        if (focus) {
          this.delay(() => {
            this.scrollToResults();
          }, 180);
        }
      }

      dogDescriptor() {
        const breed =
          {
            'Other Doodle': 'Doodle',
            'Other long/thick coat': 'dog'
          }[this.state.answers.breed] ||
          this.state.answers.breed;

        return `${this.state.answers.size.toLowerCase()}, ${this.state.answers.coat.toLowerCase()}-coated ${breed}`;
      }

      renderResultsHeader() {
        const answers = this.state.answers;

        this.one('[data-bq-results-title]').textContent =
          `Your grooming system for a ${this.dogDescriptor()}`;

        this.one('[data-bq-results-summary]').textContent =
          `${answers.breed} · ${answers.size} · ${answers.coat} · ${answers.length} coat · ${this.problemLabel(answers.problem)}`;
      }

      renderResult(type, keys) {
        const container = this.one(
          `[data-bq-result-products="${type}"]`
        );

        container.replaceChildren(
          ...keys.map((key) => {
            return this.createResultProduct(this.products[key]);
          })
        );

        this.one(
          `[data-bq-result-count="${type}"]`
        ).textContent = keys.length;

        this.renderResultPrice(type, keys);
        this.renderResultCopy(type, keys);
        this.updateResultButton(type, keys);
      }

      createProductImage(product, sizes) {
        const image = product?.imageTemplate?.content
          ?.querySelector('img')
          ?.cloneNode(true);

        if (!image) return null;

        image.sizes = sizes;
        image.loading = 'lazy';
        image.decoding = 'async';

        return image;
      }

      createResultProduct(product) {
        const item = document.createElement('li');
        item.className = 'bq2__result-product';

        const image = this.createProductImage(
          product,
          '(max-width: 620px) 38vw, (max-width: 860px) 18vw, 122px'
        );

        if (image) {
          item.append(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'bq2__product-placeholder';

          placeholder.textContent = product?.id
            ? 'Product image unavailable'
            : 'Choose product in the theme editor';

          item.append(placeholder);
        }

        const label = document.createElement('span');
        label.textContent = product?.label || 'Product';
        item.append(label);

        return item;
      }

      renderResultPrice(type, keys) {
        const originalTotal = this.totalPrice(keys);
        const discount = this.discountForCount(keys.length);

        const currentTotal = this.applyDiscount(
          originalTotal,
          discount
        );

        const current = this.one(
          `[data-bq-result-price="${type}"]`
        );

        const original = this.one(
          `[data-bq-result-original="${type}"]`
        );

        const save = this.one(
          `[data-bq-result-save="${type}"]`
        );

        const row = current.closest('.bq2__price-row');
        const currentMoney = this.money(currentTotal);
        const originalMoney = this.money(originalTotal);

        current.textContent = currentMoney;

        current.setAttribute(
          'aria-label',
          `Bundle price ${currentMoney}`
        );

        original.textContent = originalMoney;

        original.setAttribute(
          'aria-label',
          `Original price ${originalMoney}`
        );

        save.textContent = `You save ${discount}%`;

        original.hidden = discount <= 0;
        save.hidden = discount <= 0;
        row.classList.toggle('is-single', discount <= 0);
      }

      renderResultCopy(type, keys) {
        const target = this.one(
          `[data-bq-result-copy="${type}"]`
        );

        const descriptor = this.dogDescriptor();
        let paragraphs = [];

        if (type === 'minimum') {
          const isSmall = this.state.answers.size === 'Small';

          const brush = isSmall
            ? this.products.shfs.label
            : this.products.dhfs.label;

          const comb = this.products.fc.label;

          const productExplanation = isSmall
            ? `If you just want the basics for your ${descriptor}, the ${brush} + ${comb} give you the two essentials: a gentle, appropriately sized brush for detangling, plus the comb that tells you whether the job is actually finished.`
            : `If you just want the basics for your ${descriptor}, the ${brush} + ${comb} give you the two essentials: fast, effective full-body brushing, plus the comb that tells you whether you’ve actually removed every tangle.`;

          paragraphs = [
            productExplanation,
            MINIMUM_PROBLEM_COPY[this.state.answers.problem]
          ];
        } else {
          const opening =
            `For the best results with your ${descriptor}, we’d recommend the ${this.formatProductList(keys)}.`;

          const isFourToolShaveDownResult =
            this.result.includeElps &&
            this.state.answers.problem === 'shave';

          const setExplanation = this.result.includeElps
            ? 'Each tool has a different job: fast body brushing with the Double Head, precision work with the Single Head, maximum undercoat reach with the Extra Long Pin Slicker, then a final comb-through to confirm the coat is completely tangle-free.'
            : 'The Double Head handles the main body quickly, the smaller Single Head gets into awkward areas like behind the ears, around the face, legs and paws, and the Finishing Comb checks that you haven’t missed anything.';

          paragraphs = isFourToolShaveDownResult
            ? [
                opening,
                'The Double Head makes full-body brushing faster, the Single Head gets into awkward areas, and the Extra Long Pin Slicker gives you maximum reach into the deeper coat. Finish with the comb to make sure nothing has been missed — giving you the best chance of avoiding hidden matting and an unexpected shave-down.'
              ]
            : [
                opening,
                setExplanation,
                RECOMMENDED_PROBLEM_COPY[this.state.answers.problem]
              ];
        }

        target.replaceChildren(
          ...paragraphs.filter(Boolean).map((text) => {
            const paragraph = document.createElement('p');
            paragraph.textContent = text;
            return paragraph;
          })
        );
      }

      formatProductList(keys) {
        const labels = keys.map((key) => {
          return this.products[key]?.label || key;
        });

        if (labels.length <= 1) {
          return labels[0] || '';
        }

        if (labels.length === 2) {
          return labels.join(' + ');
        }

        return `${labels.slice(0, -1).join(', ')} + ${labels[labels.length - 1]}`;
      }

      updateResultButton(type, keys) {
        const button = this.one(`[data-bq-add="${type}"]`);

        const ready = keys.every((key) => {
          return this.products[key]?.available;
        });

        button.disabled = !ready;

        button.textContent = ready
          ? this.data.addLabel || 'Add to cart'
          : 'Products unavailable';
      }

      renderBuilder() {
        const container = this.one('[data-bq-builder-products]');
        const keys = ['dhfs', 'shfs', 'elps', 'fc'];

        this.customSelection = new Set(
          [...this.customSelection].filter((key) => keys.includes(key))
        );

        container.replaceChildren(
          ...keys.map((key) => {
            return this.createBuilderProduct(
              this.products[key],
              this.customSelection.has(key)
            );
          })
        );

        this.updateBuilderSummary();
      }

      createBuilderProduct(product, selected) {
        const wrapper = document.createElement('div');
        wrapper.className = 'bq2__builder-choice';

        const input = document.createElement('input');
        input.className = 'bq2__builder-input';
        input.type = 'checkbox';
        input.id =
          `bq2-${this.data.sectionId}-builder-${product.key}`;
        input.value = product.key;
        input.checked = Boolean(selected && product.available);
        input.disabled = !product.available;
        input.dataset.bqBuilderInput = '';

        const label = document.createElement('label');
        label.className = 'bq2__builder-card';
        label.htmlFor = input.id;

        const check = document.createElement('span');
        check.className = 'bq2__builder-check';
        check.textContent = '✓';
        check.setAttribute('aria-hidden', 'true');
        label.append(check);

        const image = this.createProductImage(
          product,
          '(max-width: 440px) 40vw, 180px'
        );

        if (image) {
          label.append(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'bq2__product-placeholder';

          placeholder.textContent = product.id
            ? 'Image unavailable'
            : 'Choose product in the theme editor';

          label.append(placeholder);
        }

        const title = document.createElement('strong');
        title.textContent = product.label;
        label.append(title);

        const price = document.createElement('b');
        price.textContent = this.money(product.price);
        label.append(price);

        if (!product.available) {
          const stock = document.createElement('span');
          stock.className = 'bq2__stock';

          stock.textContent = product.id
            ? 'Currently unavailable'
            : 'Select this product in the theme editor';

          label.append(stock);
        }

        wrapper.append(input, label);
        return wrapper;
      }

      updateBuilderSummary() {
        const keys = [...this.customSelection];
        const originalTotal = this.totalPrice(keys);
        const discount = this.discountForCount(keys.length);

        const currentTotal = this.applyDiscount(
          originalTotal,
          discount
        );

        const discountRow = this.one(
          '[data-bq-builder-discount]'
        );

        const original = this.one(
          '[data-bq-builder-original]'
        );

        const save = this.one('[data-bq-builder-save]');
        const button = this.one('[data-bq-add="custom"]');
        const price = this.one('[data-bq-builder-price]');

        const currentMoney = this.money(currentTotal);
        const originalMoney = this.money(originalTotal);

        this.one('[data-bq-builder-count]').textContent =
          keys.length;

        price.textContent = currentMoney;

        price.setAttribute(
          'aria-label',
          `Bundle price ${currentMoney}`
        );

        original.textContent = originalMoney;

        original.setAttribute(
          'aria-label',
          `Original price ${originalMoney}`
        );

        save.textContent = `You save ${discount}%`;

        discountRow.hidden = discount <= 0;
        original.hidden = discount <= 0;
        save.hidden = discount <= 0;

        const ready =
          keys.length > 0 &&
          keys.every((key) => {
            return this.products[key]?.available;
          });

        button.disabled = !ready;

        button.textContent = keys.length
          ? this.data.addLabel || 'Add to cart'
          : 'Choose at least one tool';
      }

      totalPrice(keys) {
        return keys.reduce((total, key) => {
          return total + (this.products[key]?.price || 0);
        }, 0);
      }

      discountForCount(count) {
        if (count < 2) return 0;

        const fallbacks = {
          2: 10,
          3: 15,
          4: 30
        };

        const tier = count >= 4 ? 4 : count;

        const raw =
          tier === 4
            ? this.data.discount4
            : tier === 3
              ? this.data.discount3
              : this.data.discount2;

        const trimmed = String(raw ?? '').trim();
        const value = Number(trimmed);

        if (trimmed === '' || !Number.isFinite(value)) {
          return fallbacks[tier];
        }

        return Math.min(Math.max(value, 0), 90);
      }

      discountCodeForCount(count) {
        if (count >= 4) {
          return (this.data.discountCode4 || '').trim();
        }

        if (count === 3) {
          return (this.data.discountCode3 || '').trim();
        }

        if (count === 2) {
          return (this.data.discountCode2 || '').trim();
        }

        return '';
      }

      applyDiscount(total, percent) {
        return Math.max(
          0,
          Math.round((total * (100 - percent)) / 100)
        );
      }

      money(cents) {
        const currency = this.data.currency || 'GBP';

        const locale =
          this.data.locale ||
          document.documentElement.lang ||
          'en-GB';

        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return `${currency} ${((Number(cents) || 0) / 100).toFixed(2)}`;
        }
      }

      getCartSurface() {
        return document.querySelector(
          'cart-drawer, cart-notification'
        );
      }

      getCartSectionIds() {
        const cartSurface = this.getCartSurface();

        if (
          !cartSurface ||
          typeof cartSurface.getSectionsToRender !== 'function'
        ) {
          return [];
        }

        try {
          return [
            ...new Set(
              cartSurface
                .getSectionsToRender()
                .map((section) => section?.id)
                .filter(Boolean)
            )
          ].slice(0, 5);
        } catch (error) {
          return [];
        }
      }

      async cartRequest(url, options = {}) {
        const response = await fetch(url, options);
        let body = {};

        try {
          body = await response.json();
        } catch (error) {
          body = {};
        }

        if (!response.ok) {
          throw new Error(
            body.description ||
            body.message ||
            'The cart could not be updated.'
          );
        }

        return body;
      }

      updateCartCount(cart) {
        const count = Number(cart?.item_count || 0);

        const selectors = [
          '[data-cart-count]',
          '.cart-count-bubble span[aria-hidden="true"]',
          '#CartCount',
          '.site-header__cart-count'
        ].join(', ');

        document.querySelectorAll(selectors).forEach((element) => {
          if (element.children.length === 0) {
            element.textContent = String(count);
          }
        });
      }

      openSlideCart(cart) {
        let opened = false;

        const open = () => {
          if (opened) return;

          opened = true;

          if (typeof window.SLIDECART_OPEN === 'function') {
            window.SLIDECART_OPEN();
          }
        };

        if (
          cart &&
          typeof window.SLIDECART_SET_CART === 'function'
        ) {
          window.SLIDECART_SET_CART(cart);
          open();
          return true;
        }

        if (typeof window.SLIDECART_UPDATE === 'function') {
          try {
            const updateResult = window.SLIDECART_UPDATE(open);

            if (
              updateResult &&
              typeof updateResult.then === 'function'
            ) {
              updateResult
                .then(open)
                .catch(() => {});
            }
          } catch (updateError) {
            try {
              window.SLIDECART_UPDATE();
            } catch (ignoredError) {
              /* No action required. */
            }
          }

          this.delay(open, 600);
          return true;
        }

        if (typeof window.SLIDECART_OPEN === 'function') {
          open();
          return true;
        }

        return false;
      }

      refreshCartUi(cart, cartSections, addedItem) {
        if (cart) {
          this.updateCartCount(cart);
        }

        const eventDetail = {
          cart,
          item: addedItem || null,
          source: 'brush-quiz'
        };

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: eventDetail
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            detail: eventDetail
          })
        );

        if (this.openSlideCart(cart)) {
          return;
        }

        const cartSurface = this.getCartSurface();

        if (
          cartSurface &&
          typeof cartSurface.renderContents === 'function' &&
          cartSections
        ) {
          cartSurface.renderContents({
            ...(cart || {}),
            id:
              addedItem?.id ||
              addedItem?.variant_id,
            key:
              addedItem?.key ||
              cart?.items?.[0]?.key,
            sections: cartSections
          });

          if (typeof cartSurface.open === 'function') {
            cartSurface.open();
          }
        }
      }

      async addToCart(type, button) {
        if (
          !button ||
          button.dataset.cartBusy === 'true'
        ) {
          return;
        }

        this.hideError(this.cartError);
        this.announceCart('');

        const keys =
          type === 'custom'
            ? [...this.customSelection]
            : this.result?.[type];

        if (!keys?.length) {
          this.showError(
            this.cartError,
            'Choose at least one tool before adding the kit.'
          );

          return;
        }

        const products = keys.map((key) => {
          return this.products[key];
        });

        const unavailable = products.find((product) => {
          return !product?.available || !product.id;
        });

        if (unavailable) {
          this.showError(
            this.cartError,
            `${unavailable?.label || 'A product'} is unavailable or not configured.`
          );

          return;
        }

        const ids = products.map((product) => product.id);

        if (new Set(ids).size !== ids.length) {
          this.showError(
            this.cartError,
            'Each quiz tool must use a different Shopify product.'
          );

          return;
        }

        const originalText = button.textContent.trim();

        button.dataset.cartBusy = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';

        const bundle =
          type === 'custom'
            ? 'Custom'
            : `${type.charAt(0).toUpperCase()}${type.slice(1)}`;

        const answerSummary = [
          this.state.answers.breed,
          this.state.answers.size,
          this.state.answers.coat,
          this.state.answers.length,
          this.problemLabel(this.state.answers.problem)
        ].join(' | ');

        const items = products.map((product) => {
          return {
            id: Number(product.id),
            quantity: 1,
            properties: {
              '_Brush quiz bundle': bundle,
              '_Brush quiz answers': answerSummary
            }
          };
        });

        let itemsWereAdded = false;

        try {
          const configuredRoot =
            window.Shopify?.routes?.root || '/';

          const shopRoot = configuredRoot.endsWith('/')
            ? configuredRoot
            : `${configuredRoot}/`;

          const sectionIds = this.getCartSectionIds();

          const sectionsUrl =
            `${window.location.pathname}${window.location.search}`;

          const addPayload = {
            items
          };

          if (sectionIds.length) {
            addPayload.sections = sectionIds;
            addPayload.sections_url = sectionsUrl;
          }

          const addBody = await this.cartRequest(
            `${shopRoot}cart/add.js`,
            {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(addPayload)
            }
          );

          itemsWereAdded = true;

          const code = this.discountCodeForCount(keys.length);
          let fullCart = null;
          let cartSections = addBody.sections || null;
          let discountWarning = '';

          if (code) {
            const discountPayload = {
              discount: code
            };

            if (sectionIds.length) {
              discountPayload.sections = sectionIds;
              discountPayload.sections_url = sectionsUrl;
            }

            try {
              fullCart = await this.cartRequest(
                `${shopRoot}cart/update.js`,
                {
                  method: 'POST',
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(discountPayload)
                }
              );

              cartSections =
                fullCart.sections ||
                cartSections;
            } catch (discountError) {
              console.error(
                'Brush quiz discount error:',
                discountError
              );

              discountWarning =
                'The tools were added, but the discount code could not be applied automatically. Please check your cart.';
            }
          }

          if (!fullCart) {
            try {
              fullCart = await this.cartRequest(
                `${shopRoot}cart.js`,
                {
                  method: 'GET',
                  headers: {
                    Accept: 'application/json'
                  },
                  cache: 'no-store'
                }
              );
            } catch (cartRefreshError) {
              console.error(
                'Brush quiz cart refresh error:',
                cartRefreshError
              );
            }
          }

          const addedItem =
            addBody?.items?.[0] ||
            addBody ||
            null;

          this.refreshCartUi(
            fullCart,
            cartSections,
            addedItem
          );

          const analyticsDetail = {
            bundle: type,
            products: [...keys],
            answers: {
              ...this.state.answers
            }
          };

          this.emit(
            'brush-quiz:add-to-cart',
            {
              ...analyticsDetail,
              cart: fullCart
            }
          );

          this.pushDataLayer(
            'brush_quiz_add_to_cart',
            analyticsDetail
          );

          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = 'Added ✓';

          this.announceCart(
            `${keys.length} tools added to your cart.`
          );

          if (discountWarning) {
            this.showError(
              this.cartError,
              discountWarning
            );
          }

          this.delay(() => {
            delete button.dataset.cartBusy;
            button.textContent = originalText;
          }, 1600);
        } catch (error) {
          console.error(
            'Brush quiz add-to-cart error:',
            error
          );

          const message = itemsWereAdded
            ? 'The tools were added, but the cart display could not refresh. Open the cart to confirm them.'
            : error.message ||
              'The kit could not be added. Please try again.';

          this.showError(
            this.cartError,
            message
          );

          button.disabled = false;
          button.removeAttribute('aria-busy');

          if (itemsWereAdded) {
            button.textContent = 'Added ✓';

            this.announceCart(
              `${keys.length} tools added to your cart.`
            );

            this.delay(() => {
              delete button.dataset.cartBusy;
              button.textContent = originalText;
            }, 1600);
          } else {
            delete button.dataset.cartBusy;
            button.textContent = originalText;
          }
        }
      }

      reset() {
        this.state = {
          step: 1,
          answers: {},
          completed: false
        };

        this.result = null;
        this.customSelection.clear();
        this.form.reset();
        this.showQuizView();
        this.hideError(this.formError);
        this.hideError(this.cartError);
        this.announceCart('');

        try {
          sessionStorage.removeItem(this.storageKey);
        } catch (error) {
          /* Storage may be unavailable. */
        }

        this.goToStep(1);
      }

      restoreState() {
        if (this.data.persist !== 'true') {
          return;
        }

        try {
          const saved = JSON.parse(
            sessionStorage.getItem(this.storageKey)
          );

          if (
            !saved ||
            typeof saved !== 'object'
          ) {
            return;
          }

          this.state = {
            step: Number(saved.step) || 1,
            answers:
              saved.answers &&
              typeof saved.answers === 'object'
                ? saved.answers
                : {},
            completed: Boolean(saved.completed)
          };
        } catch (error) {
          /* Invalid session data is ignored. */
        }
      }

      saveState() {
        if (this.data.persist !== 'true') {
          return;
        }

        try {
          sessionStorage.setItem(
            this.storageKey,
            JSON.stringify(this.state)
          );
        } catch (error) {
          /* Storage may be unavailable. */
        }
      }

      showError(element, message) {
        if (!element) return;

        element.textContent = message;
        element.hidden = false;

        element.focus({
          preventScroll: false
        });
      }

      hideError(element) {
        if (!element) return;

        element.hidden = true;
        element.textContent = '';
      }

      announceCart(message) {
        if (this.cartStatus) {
          this.cartStatus.textContent = message;
        }
      }

      scrollToTop() {
        const reduced = window
          .matchMedia('(prefers-reduced-motion: reduce)')
          .matches;

        const stickyHeader = document.querySelector(
          'sticky-header, .shopify-section-header-sticky, #shopify-section-header'
        );

        const headerHeight = stickyHeader
          ? Math.min(
              stickyHeader.getBoundingClientRect().height,
              140
            )
          : 0;

        const targetTop =
          window.scrollY +
          this.root.getBoundingClientRect().top -
          headerHeight -
          16;

        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: reduced ? 'auto' : 'smooth'
        });
      }

      scrollToResults() {
        const target = this.one(
          '[data-bq-results-header]'
        );

        if (!target) return;

        const reduced = window
          .matchMedia('(prefers-reduced-motion: reduce)')
          .matches;

        const stickyHeader = document.querySelector(
          'sticky-header, .shopify-section-header-sticky, #shopify-section-header'
        );

        const headerHeight = stickyHeader
          ? Math.min(
              stickyHeader.getBoundingClientRect().height,
              140
            )
          : 0;

        const targetTop =
          window.scrollY +
          target.getBoundingClientRect().top -
          headerHeight -
          16;

        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: reduced ? 'auto' : 'smooth'
        });

        target.focus({
          preventScroll: true
        });
      }

      emit(name, detail) {
        this.root.dispatchEvent(
          new CustomEvent(name, {
            bubbles: true,
            detail
          })
        );
      }

      pushDataLayer(event, detail) {
        if (!Array.isArray(window.dataLayer)) {
          return;
        }

        window.dataLayer.push({
          event,
          brush_quiz: detail
        });
      }
    }

    const initialize = (root) => {
      if (
        !root ||
        root.dataset.initialized === 'true'
      ) {
        return;
      }

      new BrushQuizV2(root).init();
    };

    const initializeAll = (scope = document) => {
      if (
        scope instanceof Element &&
        scope.matches('[data-bq-root]')
      ) {
        initialize(scope);
      }

      scope
        .querySelectorAll?.('[data-bq-root]')
        .forEach(initialize);
    };

    const destroyAll = (scope) => {
      if (
        scope instanceof Element &&
        scope.matches('[data-bq-root]')
      ) {
        scope.__brushQuizV2?.destroy();
      }

      scope
        .querySelectorAll?.('[data-bq-root]')
        .forEach((root) => {
          root.__brushQuizV2?.destroy();
        });
    };

    window.BrushQuizV2Controller = {
      initializeAll,
      destroyAll
    };

    initializeAll(document);

    if (!window.__brushQuizV2EditorListeners) {
      window.__brushQuizV2EditorListeners = true;

      document.addEventListener(
        'shopify:section:load',
        (event) => {
          window.BrushQuizV2Controller?.initializeAll(
            event.target
          );
        }
      );

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          window.BrushQuizV2Controller?.destroyAll(
            event.target
          );
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brush-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STEP_KEYS = [
      'breed',
      'size',
      'coat',
      'length',
      'problem'
    ];

    const PROBLEM_LABELS = Object.freeze({
      shave: 'I’m worried about shave-downs',
      sensitive: 'They don’t like being brushed',
      time: 'Brushing takes too long',
      tangles: 'I brush often but still find tangles',
      cost: 'My grooming bills are too expensive',
      new: 'I’m new to brushing this type of coat'
    });

    const PROBLEM_SUMMARIES = Object.freeze({
      shave: 'Avoiding shave-downs',
      sensitive: 'Brush-sensitive',
      time: 'Faster brushing',
      tangles: 'Still finding tangles',
      cost: 'Lower grooming costs',
      new: 'New to coat care'
    });

    const MINIMUM_PROBLEM_COPY = Object.freeze({
      shave:
        'That final comb check is especially important if you’re worried about shave-downs — brushing can look finished while tangles are still hiding deeper in the coat.',

      sensitive:
        'The flexible head absorbs resistance as you brush, making this a much gentler, more comfortable starting point for a brush-sensitive dog.',

      time:
        'This keeps the routine simple: one effective brush for the main job, then a quick comb-through to confirm you’re done.',

      cost:
        'Keeping the coat properly detangled at home can help reduce the matting, dematting work and shave-downs that often make grooming appointments more expensive.',

      tangles:
        'If you keep finding tangles after brushing, the comb is the missing check: if it snags, you know exactly where you need to go back and brush again.',

      new:
        'This gives you the simplest correct routine to start with: detangle with the brush, then check your work with the comb.'
    });

    const RECOMMENDED_PROBLEM_COPY = Object.freeze({
      shave:
        'If avoiding shave-downs is the goal, this gives you much better coverage of the whole coat — and the comb check means you know the job is finished rather than hoping it is.',

      sensitive:
        'Both flexible slickers absorb resistance as you brush, making the experience much more comfortable while still giving you the coverage you need across the body and tricky areas.',

      time:
        'This setup makes brushing more efficient instead of forcing one brush to do four different jobs, with the Double Head particularly useful for cutting down full-body brushing time.',

      cost:
        'This gives you a much more complete home-maintenance routine, helping prevent the hidden matting that can lead to dematting charges, difficult grooming appointments and expensive shave-downs.',

      tangles:
        'This removes the guesswork: the brushes tackle different areas and depths of the coat, then the comb tells you immediately if anything has been missed.',

      new:
        'Starting with the full routine means you have the right tool for each job from day one, rather than learning through missed tangles, uncomfortable brushing or preventable matting.'
    });

    class BrushQuizV2 {
      constructor(root) {
        this.root = root;
        this.data = root.dataset;
        this.products = {};
        this.result = null;
        this.customSelection = new Set();
        this.abortController =
          new AbortController();
        this.timers = new Set();

        this.storageKey =
          `brush-quiz-v2-${this.data.sectionId}`;

        this.state = {
          step: 1,
          answers: {},
          completed: false
        };
      }

      one(selector) {
        return this.root.querySelector(selector);
      }

      all(selector) {
        return [
          ...this.root.querySelectorAll(selector)
        ];
      }

      delay(callback, milliseconds) {
        const timer = window.setTimeout(() => {
          this.timers.delete(timer);
          callback();
        }, milliseconds);

        this.timers.add(timer);
        return timer;
      }

      init() {
        if (
          this.root.dataset.initialized ===
          'true'
        ) {
          return;
        }

        this.root.dataset.initialized = 'true';
        this.root.__brushQuizV2 = this;

        this.form = this.one('[data-bq-form]');

        this.placeholder = this.one(
          '[data-bq-placeholder]'
        );

        this.results = this.one(
          '[data-bq-results]'
        );

        this.progress = this.one(
          '[data-bq-progress]'
        );

        this.progressCopy = this.one(
          '[data-bq-progress-copy]'
        );

        this.selectionStatus = this.one(
          '[data-bq-selection-status]'
        );

        this.placeholderProgress = this.one(
          '[data-bq-placeholder-progress]'
        );

        this.placeholderSummary = this.one(
          '[data-bq-placeholder-summary]'
        );

        this.formError = this.one(
          '[data-bq-form-error]'
        );

        this.cartError = this.one(
          '[data-bq-cart-error]'
        );

        this.cartStatus = this.one(
          '[data-bq-cart-status]'
        );

        if (
          !this.form ||
          !this.placeholder ||
          !this.results ||
          !this.progress
        ) {
          this.destroy();
          return;
        }

        this.products = this.readProducts();

        this.restoreState();
        this.sanitizeState();
        this.syncInputsFromState();
        this.bindEvents();
        this.updatePlaceholder();

        if (
          this.state.completed &&
          this.hasEveryAnswer()
        ) {
          this.buildResults(false, false);
        } else {
          this.showQuizView();
          this.goToStep(this.state.step, false);
        }
      }

      destroy() {
        this.abortController.abort();

        this.timers.forEach((timer) => {
          window.clearTimeout(timer);
        });

        this.timers.clear();

        delete this.root.__brushQuizV2;
        delete this.root.dataset.initialized;
      }

      showQuizView() {
        this.root.classList.remove(
          'is-results-view'
        );

        this.root.classList.add(
          'is-quiz-view'
        );

        this.placeholder.hidden = true;
        this.results.hidden = true;
      }

      showResultsView() {
        this.root.classList.remove(
          'is-quiz-view'
        );

        this.root.classList.add(
          'is-results-view'
        );

        this.placeholder.hidden = true;
        this.results.hidden = false;
      }

      readProducts() {
        const products = {};

        this.all('[data-bq-product]').forEach(
          (element) => {
            const key = element.dataset.key;

            if (!key) return;

            const imageTemplate =
              element.querySelector(
                '[data-bq-product-image]'
              );

            products[key] = {
              key,

              id:
                element.dataset.variantId ||
                '',

              price: Number(
                element.dataset.price || 0
              ),

              title:
                element.dataset.title ||
                element.dataset.label ||
                key,

              label:
                element.dataset.label ||
                element.dataset.title ||
                key,

              imageTemplate,

              available:
                element.dataset.available ===
                  'true' &&
                Boolean(
                  element.dataset.variantId
                )
            };
          }
        );

        return products;
      }

      bindEvents() {
        const options = {
          signal:
            this.abortController.signal
        };

        this.root.addEventListener(
          'change',
          (event) => {
            if (
              !(
                event.target instanceof
                HTMLInputElement
              )
            ) {
              return;
            }

            if (
              event.target.matches(
                '[data-bq-answer]'
              )
            ) {
              this.handleAnswer(event.target);
              return;
            }

            if (
              !event.target.matches(
                '[data-bq-builder-input]'
              )
            ) {
              return;
            }

            const key = event.target.value;

            if (
              !this.products[key]?.available
            ) {
              event.target.checked = false;
              this.customSelection.delete(key);
            } else if (
              event.target.checked
            ) {
              this.customSelection.add(key);
            } else {
              this.customSelection.delete(key);
            }

            this.updateBuilderSummary();
          },
          options
        );

        this.root.addEventListener(
          'click',
          (event) => {
            if (
              !(
                event.target instanceof
                Element
              )
            ) {
              return;
            }

            const nextButton =
              event.target.closest(
                '[data-bq-next]'
              );

            if (nextButton) {
              event.preventDefault();

              this.handleNext(nextButton);
              return;
            }

            const backButton =
              event.target.closest(
                '[data-bq-back]'
              );

            if (backButton) {
              event.preventDefault();

              const currentStep = Number(
                backButton
                  .closest('[data-bq-step]')
                  ?.dataset.bqStep || 1
              );

              this.goToStep(
                Math.max(
                  1,
                  currentStep - 1
                )
              );

              return;
            }

            const addButton =
              event.target.closest(
                '[data-bq-add]'
              );

            if (addButton) {
              event.preventDefault();

              this.addToCart(
                addButton.dataset.bqAdd,
                addButton
              );

              return;
            }

            if (
              event.target.closest(
                '[data-bq-reset]'
              )
            ) {
              event.preventDefault();
              this.reset();
            }
          },
          options
        );

        this.form.addEventListener(
          'submit',
          (event) => {
            event.preventDefault();

            this.syncStateFromInputs();

            if (!this.hasEveryAnswer()) {
              const missingIndex =
                STEP_KEYS.findIndex(
                  (key) =>
                    !this.state.answers[key]
                );

              this.goToStep(
                missingIndex + 1
              );

              this.showError(
                this.formError,
                'Please choose an answer before continuing.'
              );

              return;
            }

            this.buildResults(true, true);
          },
          options
        );
      }

      handleAnswer(input) {
        if (
          !input?.checked ||
          !STEP_KEYS.includes(
            input.dataset.bqAnswer
          )
        ) {
          return;
        }

        this.state.answers[
          input.dataset.bqAnswer
        ] = input.value;

        this.state.completed = false;

        this.hideError(this.formError);
        this.updateStepButton();
        this.updatePlaceholder();
        this.saveState();
      }

      syncStateFromInputs() {
        this.all(
          '[data-bq-answer]:checked'
        ).forEach((input) => {
          const key =
            input.dataset.bqAnswer;

          if (STEP_KEYS.includes(key)) {
            this.state.answers[key] =
              input.value;
          }
        });
      }

      syncInputsFromState() {
        this.all(
          '[data-bq-answer]'
        ).forEach((input) => {
          input.checked =
            this.state.answers[
              input.dataset.bqAnswer
            ] === input.value;
        });
      }

      sanitizeState() {
        const validValues = {};

        STEP_KEYS.forEach((key) => {
          validValues[key] = new Set(
            this.all(
              `[data-bq-answer="${key}"]`
            ).map((input) => input.value)
          );
        });

        const safeAnswers = {};

        STEP_KEYS.forEach((key) => {
          const value =
            this.state.answers?.[key];

          if (
            validValues[key].has(value)
          ) {
            safeAnswers[key] = value;
          }
        });

        this.state.answers = safeAnswers;

        this.state.step = Math.max(
          1,
          Math.min(
            STEP_KEYS.length,
            Number(this.state.step) || 1
          )
        );

        this.state.completed = Boolean(
          this.state.completed &&
          this.hasEveryAnswer()
        );
      }

      handleNext(button) {
        this.syncStateFromInputs();

        const currentStep = Number(
          button
            .closest('[data-bq-step]')
            ?.dataset.bqStep
        );

        if (
          !Number.isInteger(currentStep) ||
          currentStep < 1 ||
          currentStep >= STEP_KEYS.length
        ) {
          return;
        }

        const key =
          STEP_KEYS[currentStep - 1];

        if (!this.state.answers[key]) {
          this.showError(
            this.formError,
            'Please choose an answer before continuing.'
          );

          this.updateStepButton();
          return;
        }

        this.goToStep(currentStep + 1);
      }

      goToStep(step, focus = true) {
        const safeStep = Math.max(
          1,
          Math.min(
            STEP_KEYS.length,
            Number(step) || 1
          )
        );

        this.state.step = safeStep;

        this.all(
          '[data-bq-step]'
        ).forEach((element) => {
          element.hidden =
            Number(
              element.dataset.bqStep
            ) !== safeStep;
        });

        this.progress.value = safeStep;

        this.progress.textContent =
          `${safeStep} of ${STEP_KEYS.length}`;

        this.progress.setAttribute(
          'aria-label',
          `Quiz progress: step ${safeStep} of ${STEP_KEYS.length}`
        );

        this.progressCopy.textContent =
          `Step ${safeStep} of ${STEP_KEYS.length}`;

        this.hideError(this.formError);
        this.updateStepButton();
        this.updatePlaceholder();
        this.saveState();

        if (!focus) return;

        this.scrollToTop();

        const question = this.one(
          `[data-bq-step="${safeStep}"] [data-bq-question]`
        );

        this.delay(() => {
          question?.focus({
            preventScroll: true
          });
        }, 180);
      }

      updateStepButton() {
        const step =
          this.one(
            '[data-bq-step]:not([hidden])'
          ) ||
          this.one(
            `[data-bq-step="${this.state.step}"]`
          );

        if (!step) return;

        const key =
          STEP_KEYS[
            Number(
              step.dataset.bqStep
            ) - 1
          ];

        const checked =
          step.querySelector(
            `[data-bq-answer="${key}"]:checked`
          );

        if (checked) {
          this.state.answers[key] =
            checked.value;
        }

        const selected =
          checked?.value ||
          this.state.answers[key] ||
          '';

        const ready = Boolean(selected);

        const action =
          step.querySelector(
            '[data-bq-next], [data-bq-submit]'
          );

        if (action) {
          action.disabled = !ready;
          action.dataset.ready =
            String(ready);
        }

        const selectedLabel =
          key === 'problem'
            ? this.problemLabel(selected)
            : selected;

        this.selectionStatus.textContent =
          ready
            ? `Selected: ${selectedLabel}. You can continue.`
            : 'Choose one option to continue.';

        this.selectionStatus.classList.toggle(
          'is-ready',
          ready
        );
      }

      updatePlaceholder() {
        const completed =
          STEP_KEYS.filter(
            (key) =>
              Boolean(
                this.state.answers[key]
              )
          ).length;

        this.placeholderProgress.textContent =
          `${completed} of ${STEP_KEYS.length} answers complete`;

        const summary =
          STEP_KEYS
            .filter(
              (key) =>
                this.state.answers[key]
            )
            .map((key) => {
              if (key === 'problem') {
                return this.problemLabel(
                  this.state.answers[key]
                );
              }

              return this.state.answers[key];
            })
            .join(' · ');

        this.placeholderSummary.textContent =
          summary ||
          'Your Minimum and Recommended grooming systems will appear here.';
      }

      problemLabel(value) {
        return (
          PROBLEM_LABELS[value] ||
          value ||
          ''
        );
      }

      problemSummary(value) {
        return (
          PROBLEM_SUMMARIES[value] ||
          this.problemLabel(value)
        );
      }

      hasEveryAnswer() {
        return STEP_KEYS.every(
          (key) =>
            Boolean(
              this.state.answers[key]
            )
        );
      }

      getProductSets(answers) {
        const normalize = (value) =>
          String(value || '')
            .trim()
            .toLowerCase();

        const size = normalize(
          answers.size
        );

        const coat = normalize(
          answers.coat
        );

        const length = normalize(
          answers.length
        );

        const problem = normalize(
          answers.problem
        );

        const elpsEligibility = {
          eligibleSize:
            size === 'medium' ||
            size === 'large',

          eligibleCoat:
            coat === 'wavy' ||
            coat === 'curly',

          eligibleLength:
            length === 'medium' ||
            length === 'long',

          eligibleProblem:
            problem !== 'sensitive'
        };

        const includeElps =
          Object
            .values(elpsEligibility)
            .every(Boolean);

        const minimum = [
          size === 'small'
            ? 'shfs'
            : 'dhfs',
          'fc'
        ];

        const recommended = [
          'dhfs',
          'shfs'
        ];

        if (includeElps) {
          recommended.push('elps');
        }

        recommended.push('fc');

        return {
          minimum,
          recommended,
          includeElps,
          elpsEligibility
        };
      }

      buildResults(
        focus = true,
        track = true
      ) {
        this.syncStateFromInputs();

        if (!this.hasEveryAnswer()) {
          return;
        }

        this.result =
          this.getProductSets(
            this.state.answers
          );

        this.state.completed = true;

        this.customSelection = new Set(
          this.result.recommended.filter(
            (key) =>
              this.products[key]?.available
          )
        );

        this.renderResultsHeader();

        this.renderResult(
          'minimum',
          this.result.minimum
        );

        this.renderResult(
          'recommended',
          this.result.recommended
        );

        this.renderBuilder();
        this.showResultsView();

        this.hideError(this.cartError);
        this.announceCart('');
        this.saveState();

        const detail = {
          answers: {
            ...this.state.answers
          },

          minimum: [
            ...this.result.minimum
          ],

          recommended: [
            ...this.result.recommended
          ],

          includesExtraLongPinSlicker:
            this.result.includeElps,

          extraLongPinSlickerEligibility: {
            ...this.result.elpsEligibility
          }
        };

        if (track) {
          this.emit(
            'brush-quiz:complete',
            detail
          );

          this.pushDataLayer(
            'brush_quiz_complete',
            detail
          );
        }

        if (focus) {
          this.delay(() => {
            this.scrollToResults();
          }, 180);
        }
      }

      displayBreed() {
        const selectedBreed = String(
          this.state.answers.breed || ''
        ).trim();

        return selectedBreed || 'dog';
      }

      dogDescriptor() {
        return (
          `${this.state.answers.size.toLowerCase()}, ` +
          `${this.state.answers.coat.toLowerCase()}-coated ` +
          `${this.displayBreed()}`
        );
      }

      renderResultsHeader() {
        const answers = this.state.answers;
        const breed = this.displayBreed();

        this.one(
          '[data-bq-results-title]'
        ).textContent =
          `Your ${breed}’s personalised grooming system`;

        this.one(
          '[data-bq-results-summary]'
        ).textContent =
          `${answers.size} · ` +
          `${answers.coat} · ` +
          `${answers.length} coat · ` +
          `${this.problemSummary(answers.problem)}`;
      }
            renderResult(type, keys) {
        const container = this.one(
          `[data-bq-result-products="${type}"]`
        );

        container.replaceChildren(
          ...keys.map((key) =>
            this.createResultProduct(
              this.products[key]
            )
          )
        );

        this.one(
          `[data-bq-result-count="${type}"]`
        ).textContent = keys.length;

        this.renderResultPrice(
          type,
          keys
        );

        this.renderResultCopy(
          type,
          keys
        );

        this.updateResultButton(
          type,
          keys
        );
      }

      createProductImage(
        product,
        sizes
      ) {
        const image =
          product
            ?.imageTemplate
            ?.content
            ?.querySelector('img')
            ?.cloneNode(true);

        if (!image) return null;

        image.sizes = sizes;
        image.loading = 'lazy';
        image.decoding = 'async';

        return image;
      }

      createResultProduct(product) {
        const item =
          document.createElement('li');

        item.className =
          'bq2__result-product';

        const image =
          this.createProductImage(
            product,
            '(max-width: 620px) 38vw, (max-width: 860px) 18vw, 122px'
          );

        if (image) {
          item.append(image);
        } else {
          const placeholder =
            document.createElement(
              'span'
            );

          placeholder.className =
            'bq2__product-placeholder';

          placeholder.textContent =
            product?.id
              ? 'Product image unavailable'
              : 'Choose product in the theme editor';

          item.append(placeholder);
        }

        const label =
          document.createElement('span');

        label.textContent =
          product?.label || 'Product';

        item.append(label);

        return item;
      }

      renderResultPrice(
        type,
        keys
      ) {
        const originalTotal =
          this.totalPrice(keys);

        const discount =
          this.discountForCount(
            keys.length
          );

        const currentTotal =
          this.applyDiscount(
            originalTotal,
            discount
          );

        const current = this.one(
          `[data-bq-result-price="${type}"]`
        );

        const original = this.one(
          `[data-bq-result-original="${type}"]`
        );

        const save = this.one(
          `[data-bq-result-save="${type}"]`
        );

        const row = current.closest(
          '.bq2__price-row'
        );

        const currentMoney =
          this.money(currentTotal);

        const originalMoney =
          this.money(originalTotal);

        current.textContent =
          currentMoney;

        current.setAttribute(
          'aria-label',
          `Bundle price ${currentMoney}`
        );

        original.textContent =
          originalMoney;

        original.setAttribute(
          'aria-label',
          `Original price ${originalMoney}`
        );

        save.textContent =
          `You save ${discount}%`;

        original.hidden =
          discount <= 0;

        save.hidden =
          discount <= 0;

        row.classList.toggle(
          'is-single',
          discount <= 0
        );
      }

      renderResultCopy(
        type,
        keys
      ) {
        const target = this.one(
          `[data-bq-result-copy="${type}"]`
        );

        const descriptor =
          this.dogDescriptor();

        let paragraphs = [];

        if (type === 'minimum') {
          const isSmall =
            this.state.answers.size ===
            'Small';

          const brush =
            isSmall
              ? this.products.shfs.label
              : this.products.dhfs.label;

          const comb =
            this.products.fc.label;

          const productExplanation =
            isSmall
              ? `If you just want the basics for your ${descriptor}, the ${brush} + ${comb} give you the two essentials: a gentle, appropriately sized brush for detangling, plus the comb that tells you whether the job is actually finished.`
              : `If you just want the basics for your ${descriptor}, the ${brush} + ${comb} give you the two essentials: fast, effective full-body brushing, plus the comb that tells you whether you’ve actually removed every tangle.`;

          paragraphs = [
            productExplanation,

            MINIMUM_PROBLEM_COPY[
              this.state.answers.problem
            ]
          ];
        } else {
          const opening =
            `For the best results with your ${descriptor}, ` +
            `we’d recommend the ${this.formatProductList(keys)}.`;

          const isFourToolShaveDownResult =
            this.result.includeElps &&
            this.state.answers.problem ===
              'shave';

          const setExplanation =
            this.result.includeElps
              ? 'Each tool has a different job: fast body brushing with the Double Head, precision work with the Single Head, maximum undercoat reach with the Extra Long Pin Slicker, then a final comb-through to confirm the coat is completely tangle-free.'
              : 'The Double Head handles the main body quickly, the smaller Single Head gets into awkward areas like behind the ears, around the face, legs and paws, and the Finishing Comb checks that you haven’t missed anything.';

          paragraphs =
            isFourToolShaveDownResult
              ? [
                  opening,

                  'The Double Head makes full-body brushing faster, the Single Head gets into awkward areas, and the Extra Long Pin Slicker gives you maximum reach into the deeper coat. Finish with the comb to make sure nothing has been missed — giving you the best chance of avoiding hidden matting and an unexpected shave-down.'
                ]
              : [
                  opening,
                  setExplanation,

                  RECOMMENDED_PROBLEM_COPY[
                    this.state.answers
                      .problem
                  ]
                ];
        }

        target.replaceChildren(
          ...paragraphs
            .filter(Boolean)
            .map((text) => {
              const paragraph =
                document.createElement(
                  'p'
                );

              paragraph.textContent =
                text;

              return paragraph;
            })
        );
      }

      formatProductList(keys) {
        const labels = keys.map(
          (key) =>
            this.products[key]?.label ||
            key
        );

        if (labels.length <= 1) {
          return labels[0] || '';
        }

        if (labels.length === 2) {
          return labels.join(' + ');
        }

        return (
          `${labels
            .slice(0, -1)
            .join(', ')} + ` +
          `${labels[labels.length - 1]}`
        );
      }

      updateResultButton(
        type,
        keys
      ) {
        const button = this.one(
          `[data-bq-add="${type}"]`
        );

        const ready = keys.every(
          (key) =>
            this.products[key]?.available
        );

        button.disabled = !ready;

        button.textContent =
          ready
            ? this.data.addLabel ||
              'Add to cart'
            : 'Products unavailable';
      }

      renderBuilder() {
        const container = this.one(
          '[data-bq-builder-products]'
        );

        const keys = [
          'dhfs',
          'shfs',
          'elps',
          'fc'
        ];

        this.customSelection = new Set(
          [...this.customSelection].filter(
            (key) => keys.includes(key)
          )
        );

        container.replaceChildren(
          ...keys.map((key) =>
            this.createBuilderProduct(
              this.products[key],
              this.customSelection.has(key)
            )
          )
        );

        this.updateBuilderSummary();
      }

      createBuilderProduct(
        product,
        selected
      ) {
        const wrapper =
          document.createElement('div');

        wrapper.className =
          'bq2__builder-choice';

        const input =
          document.createElement('input');

        input.className =
          'bq2__builder-input';

        input.type = 'checkbox';

        input.id =
          `bq2-${this.data.sectionId}-builder-${product.key}`;

        input.value = product.key;

        input.checked = Boolean(
          selected &&
          product.available
        );

        input.disabled =
          !product.available;

        input.dataset.bqBuilderInput =
          '';

        const label =
          document.createElement('label');

        label.className =
          'bq2__builder-card';

        label.htmlFor = input.id;

        const check =
          document.createElement('span');

        check.className =
          'bq2__builder-check';

        check.textContent = '✓';

        check.setAttribute(
          'aria-hidden',
          'true'
        );

        label.append(check);

        const image =
          this.createProductImage(
            product,
            '(max-width: 440px) 40vw, 180px'
          );

        if (image) {
          label.append(image);
        } else {
          const placeholder =
            document.createElement(
              'span'
            );

          placeholder.className =
            'bq2__product-placeholder';

          placeholder.textContent =
            product.id
              ? 'Image unavailable'
              : 'Choose product in the theme editor';

          label.append(placeholder);
        }

        const title =
          document.createElement(
            'strong'
          );

        title.textContent =
          product.label;

        label.append(title);

        const price =
          document.createElement('b');

        price.textContent =
          this.money(product.price);

        label.append(price);

        if (!product.available) {
          const stock =
            document.createElement(
              'span'
            );

          stock.className =
            'bq2__stock';

          stock.textContent =
            product.id
              ? 'Currently unavailable'
              : 'Select this product in the theme editor';

          label.append(stock);
        }

        wrapper.append(input, label);

        return wrapper;
      }

      updateBuilderSummary() {
        const keys = [
          ...this.customSelection
        ];

        const originalTotal =
          this.totalPrice(keys);

        const discount =
          this.discountForCount(
            keys.length
          );

        const currentTotal =
          this.applyDiscount(
            originalTotal,
            discount
          );

        const discountRow = this.one(
          '[data-bq-builder-discount]'
        );

        const original = this.one(
          '[data-bq-builder-original]'
        );

        const save = this.one(
          '[data-bq-builder-save]'
        );

        const button = this.one(
          '[data-bq-add="custom"]'
        );

        const price = this.one(
          '[data-bq-builder-price]'
        );

        const currentMoney =
          this.money(currentTotal);

        const originalMoney =
          this.money(originalTotal);

        this.one(
          '[data-bq-builder-count]'
        ).textContent = keys.length;

        price.textContent =
          currentMoney;

        price.setAttribute(
          'aria-label',
          `Bundle price ${currentMoney}`
        );

        original.textContent =
          originalMoney;

        original.setAttribute(
          'aria-label',
          `Original price ${originalMoney}`
        );

        save.textContent =
          `You save ${discount}%`;

        discountRow.hidden =
          discount <= 0;

        original.hidden =
          discount <= 0;

        save.hidden =
          discount <= 0;

        const ready =
          keys.length > 0 &&
          keys.every(
            (key) =>
              this.products[key]
                ?.available
          );

        button.disabled = !ready;

        button.textContent =
          keys.length
            ? this.data.addLabel ||
              'Add to cart'
            : 'Choose at least one tool';
      }

      totalPrice(keys) {
        return keys.reduce(
          (total, key) =>
            total +
            (
              this.products[key]?.price ||
              0
            ),
          0
        );
      }

      discountForCount(count) {
        if (count < 2) return 0;

        const fallbacks = {
          2: 10,
          3: 15,
          4: 30
        };

        const tier =
          count >= 4 ? 4 : count;

        const raw =
          tier === 4
            ? this.data.discount4
            : tier === 3
              ? this.data.discount3
              : this.data.discount2;

        const trimmed =
          String(raw ?? '').trim();

        const value =
          Number(trimmed);

        if (
          trimmed === '' ||
          !Number.isFinite(value)
        ) {
          return fallbacks[tier];
        }

        return Math.min(
          Math.max(value, 0),
          90
        );
      }

      discountCodeForCount(count) {
        if (count >= 4) {
          return (
            this.data.discountCode4 ||
            ''
          ).trim();
        }

        if (count === 3) {
          return (
            this.data.discountCode3 ||
            ''
          ).trim();
        }

        if (count === 2) {
          return (
            this.data.discountCode2 ||
            ''
          ).trim();
        }

        return '';
      }

      applyDiscount(
        total,
        percent
      ) {
        return Math.max(
          0,
          Math.round(
            (
              total *
              (100 - percent)
            ) / 100
          )
        );
      }

      money(cents) {
        const currency =
          this.data.currency ||
          'GBP';

        const locale =
          this.data.locale ||
          document.documentElement.lang ||
          'en-GB';

        try {
          return new Intl.NumberFormat(
            locale,
            {
              style: 'currency',
              currency
            }
          ).format(
            (
              Number(cents) || 0
            ) / 100
          );
        } catch (error) {
          return (
            `${currency} ` +
            `${(
              (
                Number(cents) || 0
              ) / 100
            ).toFixed(2)}`
          );
        }
      }

      getCartSurface() {
        return document.querySelector(
          'cart-drawer, cart-notification'
        );
      }

      getCartSectionIds() {
        const cartSurface =
          this.getCartSurface();

        if (
          !cartSurface ||
          typeof cartSurface
            .getSectionsToRender !==
            'function'
        ) {
          return [];
        }

        try {
          return [
            ...new Set(
              cartSurface
                .getSectionsToRender()
                .map(
                  (section) =>
                    section?.id
                )
                .filter(Boolean)
            )
          ].slice(0, 5);
        } catch (error) {
          return [];
        }
      }

      async cartRequest(
        url,
        options = {}
      ) {
        const response =
          await fetch(url, options);

        let body = {};

        try {
          body =
            await response.json();
        } catch (error) {
          body = {};
        }

        if (!response.ok) {
          throw new Error(
            body.description ||
            body.message ||
            'The cart could not be updated.'
          );
        }

        return body;
      }

      updateCartCount(cart) {
        const count = Number(
          cart?.item_count || 0
        );

        const selectors = [
          '[data-cart-count]',
          '.cart-count-bubble span[aria-hidden="true"]',
          '#CartCount',
          '.site-header__cart-count'
        ].join(', ');

        document
          .querySelectorAll(selectors)
          .forEach((element) => {
            if (
              element.children.length ===
              0
            ) {
              element.textContent =
                String(count);
            }
          });
      }

      openSlideCart(cart) {
        let opened = false;

        const open = () => {
          if (opened) return;

          opened = true;

          if (
            typeof window
              .SLIDECART_OPEN ===
              'function'
          ) {
            window.SLIDECART_OPEN();
          }
        };

        if (
          cart &&
          typeof window
            .SLIDECART_SET_CART ===
            'function'
        ) {
          window.SLIDECART_SET_CART(
            cart
          );

          open();
          return true;
        }

        if (
          typeof window
            .SLIDECART_UPDATE ===
            'function'
        ) {
          try {
            const updateResult =
              window.SLIDECART_UPDATE(
                open
              );

            if (
              updateResult &&
              typeof updateResult.then ===
                'function'
            ) {
              updateResult
                .then(open)
                .catch(() => {});
            }
          } catch (updateError) {
            try {
              window.SLIDECART_UPDATE();
            } catch (ignoredError) {}
          }

          this.delay(open, 600);
          return true;
        }

        if (
          typeof window
            .SLIDECART_OPEN ===
            'function'
        ) {
          open();
          return true;
        }

        return false;
      }

      refreshCartUi(
        cart,
        cartSections,
        addedItem
      ) {
        if (cart) {
          this.updateCartCount(cart);
        }

        const eventDetail = {
          cart,
          item: addedItem || null,
          source: 'brush-quiz'
        };

        document.dispatchEvent(
          new CustomEvent(
            'cart:updated',
            {
              detail: eventDetail
            }
          )
        );

        document.dispatchEvent(
          new CustomEvent(
            'cart:refresh',
            {
              detail: eventDetail
            }
          )
        );

        if (
          this.openSlideCart(cart)
        ) {
          return;
        }

        const cartSurface =
          this.getCartSurface();

        if (
          cartSurface &&
          typeof cartSurface
            .renderContents ===
            'function' &&
          cartSections
        ) {
          cartSurface.renderContents({
            ...(cart || {}),

            id:
              addedItem?.id ||
              addedItem?.variant_id,

            key:
              addedItem?.key ||
              cart?.items?.[0]?.key,

            sections: cartSections
          });

          if (
            typeof cartSurface.open ===
              'function'
          ) {
            cartSurface.open();
          }
        }
      }
            async addToCart(
        type,
        button
      ) {
        if (
          !button ||
          button.dataset.cartBusy ===
            'true'
        ) {
          return;
        }

        this.hideError(this.cartError);
        this.announceCart('');

        const keys =
          type === 'custom'
            ? [...this.customSelection]
            : this.result?.[type];

        if (!keys?.length) {
          this.showError(
            this.cartError,
            'Choose at least one tool before adding the kit.'
          );

          return;
        }

        const products = keys.map(
          (key) => this.products[key]
        );

        const unavailable =
          products.find(
            (product) =>
              !product?.available ||
              !product.id
          );

        if (unavailable) {
          this.showError(
            this.cartError,
            `${unavailable?.label || 'A product'} is unavailable or not configured.`
          );

          return;
        }

        const ids = products.map(
          (product) => product.id
        );

        if (
          new Set(ids).size !==
          ids.length
        ) {
          this.showError(
            this.cartError,
            'Each quiz tool must use a different Shopify product.'
          );

          return;
        }

        const originalText =
          button.textContent.trim();

        button.dataset.cartBusy =
          'true';

        button.disabled = true;

        button.setAttribute(
          'aria-busy',
          'true'
        );

        button.textContent =
          'Adding…';

        const bundle =
          type === 'custom'
            ? 'Custom'
            : `${type
                .charAt(0)
                .toUpperCase()}${type.slice(1)}`;

        const answerSummary = [
          this.state.answers.breed,
          this.state.answers.size,
          this.state.answers.coat,
          this.state.answers.length,

          this.problemLabel(
            this.state.answers.problem
          )
        ].join(' | ');

        const items = products.map(
          (product) => ({
            id: Number(product.id),
            quantity: 1,

            properties: {
              '_Brush quiz bundle':
                bundle,

              '_Brush quiz answers':
                answerSummary
            }
          })
        );

        let itemsWereAdded = false;

        try {
          const configuredRoot =
            window.Shopify
              ?.routes
              ?.root || '/';

          const shopRoot =
            configuredRoot.endsWith('/')
              ? configuredRoot
              : `${configuredRoot}/`;

          const sectionIds =
            this.getCartSectionIds();

          const sectionsUrl =
            `${window.location.pathname}${window.location.search}`;

          const addPayload = {
            items
          };

          if (sectionIds.length) {
            addPayload.sections =
              sectionIds;

            addPayload.sections_url =
              sectionsUrl;
          }

          const addBody =
            await this.cartRequest(
              `${shopRoot}cart/add.js`,
              {
                method: 'POST',

                headers: {
                  Accept:
                    'application/json',

                  'Content-Type':
                    'application/json'
                },

                body: JSON.stringify(
                  addPayload
                )
              }
            );

          itemsWereAdded = true;

          const code =
            this.discountCodeForCount(
              keys.length
            );

          let fullCart = null;

          let cartSections =
            addBody.sections || null;

          let discountWarning = '';

          if (code) {
            const discountPayload = {
              discount: code
            };

            if (sectionIds.length) {
              discountPayload.sections =
                sectionIds;

              discountPayload.sections_url =
                sectionsUrl;
            }

            try {
              fullCart =
                await this.cartRequest(
                  `${shopRoot}cart/update.js`,
                  {
                    method: 'POST',

                    headers: {
                      Accept:
                        'application/json',

                      'Content-Type':
                        'application/json'
                    },

                    body: JSON.stringify(
                      discountPayload
                    )
                  }
                );

              cartSections =
                fullCart.sections ||
                cartSections;
            } catch (discountError) {
              console.error(
                'Brush quiz discount error:',
                discountError
              );

              discountWarning =
                'The tools were added, but the discount code could not be applied automatically. Please check your cart.';
            }
          }

          if (!fullCart) {
            try {
              fullCart =
                await this.cartRequest(
                  `${shopRoot}cart.js`,
                  {
                    method: 'GET',

                    headers: {
                      Accept:
                        'application/json'
                    },

                    cache: 'no-store'
                  }
                );
            } catch (
              cartRefreshError
            ) {
              console.error(
                'Brush quiz cart refresh error:',
                cartRefreshError
              );
            }
          }

          const addedItem =
            addBody?.items?.[0] ||
            addBody ||
            null;

          this.refreshCartUi(
            fullCart,
            cartSections,
            addedItem
          );

          const analyticsDetail = {
            bundle: type,
            products: [...keys],

            answers: {
              ...this.state.answers
            }
          };

          this.emit(
            'brush-quiz:add-to-cart',
            {
              ...analyticsDetail,
              cart: fullCart
            }
          );

          this.pushDataLayer(
            'brush_quiz_add_to_cart',
            analyticsDetail
          );

          button.disabled = false;

          button.removeAttribute(
            'aria-busy'
          );

          button.textContent =
            'Added ✓';

          this.announceCart(
            `${keys.length} tools added to your cart.`
          );

          if (discountWarning) {
            this.showError(
              this.cartError,
              discountWarning
            );
          }

          this.delay(() => {
            delete button.dataset
              .cartBusy;

            button.textContent =
              originalText;
          }, 1600);
        } catch (error) {
          console.error(
            'Brush quiz add-to-cart error:',
            error
          );

          const message =
            itemsWereAdded
              ? 'The tools were added, but the cart display could not refresh. Open the cart to confirm them.'
              : error.message ||
                'The kit could not be added. Please try again.';

          this.showError(
            this.cartError,
            message
          );

          button.disabled = false;

          button.removeAttribute(
            'aria-busy'
          );

          if (itemsWereAdded) {
            button.textContent =
              'Added ✓';

            this.announceCart(
              `${keys.length} tools added to your cart.`
            );

            this.delay(() => {
              delete button.dataset
                .cartBusy;

              button.textContent =
                originalText;
            }, 1600);
          } else {
            delete button.dataset
              .cartBusy;

            button.textContent =
              originalText;
          }
        }
      }

      reset() {
        this.state = {
          step: 1,
          answers: {},
          completed: false
        };

        this.result = null;
        this.customSelection.clear();
        this.form.reset();

        this.showQuizView();

        this.hideError(this.formError);
        this.hideError(this.cartError);
        this.announceCart('');

        try {
          sessionStorage.removeItem(
            this.storageKey
          );
        } catch (error) {}

        this.goToStep(1);
      }

      restoreState() {
        if (
          this.data.persist !== 'true'
        ) {
          return;
        }

        try {
          const saved = JSON.parse(
            sessionStorage.getItem(
              this.storageKey
            )
          );

          if (
            !saved ||
            typeof saved !== 'object'
          ) {
            return;
          }

          this.state = {
            step:
              Number(saved.step) || 1,

            answers:
              saved.answers &&
              typeof saved.answers ===
                'object'
                ? saved.answers
                : {},

            completed:
              Boolean(saved.completed)
          };
        } catch (error) {}
      }

      saveState() {
        if (
          this.data.persist !== 'true'
        ) {
          return;
        }

        try {
          sessionStorage.setItem(
            this.storageKey,
            JSON.stringify(this.state)
          );
        } catch (error) {}
      }

      showError(
        element,
        message
      ) {
        if (!element) return;

        element.textContent = message;
        element.hidden = false;

        element.focus({
          preventScroll: false
        });
      }

      hideError(element) {
        if (!element) return;

        element.hidden = true;
        element.textContent = '';
      }

      announceCart(message) {
        if (this.cartStatus) {
          this.cartStatus.textContent =
            message;
        }
      }

      scrollToTop() {
        if (
          window.innerWidth > 860
        ) {
          return;
        }

        const reduced =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

        this.root.scrollIntoView({
          behavior:
            reduced
              ? 'auto'
              : 'smooth',

          block: 'start'
        });
      }

      scrollToResults() {
        const target = this.one(
          '[data-bq-results-header]'
        );

        if (!target) return;

        const reduced =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

        const stickyHeader =
          document.querySelector(
            'sticky-header, .shopify-section-header-sticky, #shopify-section-header'
          );

        const headerHeight =
          stickyHeader
            ? Math.min(
                stickyHeader
                  .getBoundingClientRect()
                  .height,
                140
              )
            : 0;

        const targetTop =
          window.scrollY +
          target
            .getBoundingClientRect()
            .top -
          headerHeight -
          16;

        window.scrollTo({
          top: Math.max(
            0,
            targetTop
          ),

          behavior:
            reduced
              ? 'auto'
              : 'smooth'
        });

        target.focus({
          preventScroll: true
        });
      }

      emit(name, detail) {
        this.root.dispatchEvent(
          new CustomEvent(name, {
            bubbles: true,
            detail
          })
        );
      }

      pushDataLayer(
        event,
        detail
      ) {
        if (
          !Array.isArray(
            window.dataLayer
          )
        ) {
          return;
        }

        window.dataLayer.push({
          event,
          brush_quiz: detail
        });
      }
    }

    const initialize = (root) => {
      if (
        !root ||
        root.dataset.initialized ===
          'true'
      ) {
        return;
      }

      new BrushQuizV2(root).init();
    };

    const initializeAll = (
      scope = document
    ) => {
      if (
        scope instanceof Element &&
        scope.matches(
          '[data-bq-root]'
        )
      ) {
        initialize(scope);
      }

      scope
        .querySelectorAll?.(
          '[data-bq-root]'
        )
        .forEach(initialize);
    };

    const destroyAll = (scope) => {
      if (
        scope instanceof Element &&
        scope.matches(
          '[data-bq-root]'
        )
      ) {
        scope.__brushQuizV2
          ?.destroy();
      }

      scope
        .querySelectorAll?.(
          '[data-bq-root]'
        )
        .forEach((root) => {
          root.__brushQuizV2
            ?.destroy();
        });
    };

    window.BrushQuizV2Controller = {
      initializeAll,
      destroyAll
    };

    initializeAll(document);

    if (
      !window
        .__brushQuizV2EditorListeners
    ) {
      window
        .__brushQuizV2EditorListeners =
        true;

      document.addEventListener(
        'shopify:section:load',
        (event) => {
          window
            .BrushQuizV2Controller
            ?.initializeAll(
              event.target
            );
        }
      );

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          window
            .BrushQuizV2Controller
            ?.destroyAll(
              event.target
            );
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nightmare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nightmare-carousel')) {
    class NightmareCarousel extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;

        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.track = this.querySelector('[data-carousel-track]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');

        if (
          !this.viewport ||
          !this.track ||
          !this.previousButton ||
          !this.nextButton
        ) {
          return;
        }

        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.previousButton.addEventListener(
          'click',
          () => this.scrollByCard(-1),
          { signal }
        );

        this.nextButton.addEventListener(
          'click',
          () => this.scrollByCard(1),
          { signal }
        );

        this.viewport.addEventListener(
          'keydown',
          (event) => {
            if (
              event.key !== 'ArrowLeft' &&
              event.key !== 'ArrowRight'
            ) {
              return;
            }

            event.preventDefault();
            this.scrollByCard(event.key === 'ArrowLeft' ? -1 : 1);
          },
          { signal }
        );

        let animationFrame;

        this.viewport.addEventListener(
          'scroll',
          () => {
            if (animationFrame) return;

            animationFrame = requestAnimationFrame(() => {
              animationFrame = null;
              this.updateControls();
            });
          },
          { passive: true, signal }
        );

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(
            () => this.updateControls()
          );

          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.track);
        }

        requestAnimationFrame(() => this.updateControls());
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = null;
        this.resizeObserver = null;
      }

      get scrollStep() {
        const firstCard = this.track.querySelector('.nightmare-review');
        if (!firstCard) return 0;

        const styles = getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;

        return firstCard.getBoundingClientRect().width + gap;
      }

      get maxScroll() {
        return Math.max(
          0,
          this.viewport.scrollWidth - this.viewport.clientWidth
        );
      }

      scrollByCard(direction) {
        const step = this.scrollStep;
        if (!step) return;

        const isRtl = getComputedStyle(this.viewport).direction === 'rtl';
        const signedDirection = isRtl ? direction * -1 : direction;

        this.viewport.scrollBy({
          left: step * signedDirection,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth'
        });
      }

      updateControls() {
        const maxScroll = this.maxScroll;
        const hasOverflow = maxScroll > 2;
        const position = Math.abs(this.viewport.scrollLeft);

        this.previousButton.hidden = !hasOverflow;
        this.nextButton.hidden = !hasOverflow;
        this.previousButton.disabled = !hasOverflow || position <= 1;
        this.nextButton.disabled = !hasOverflow || position >= maxScroll - 1;
      }
    }

    customElements.define('nightmare-carousel', NightmareCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
